import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { LabService } from 'src/app/_service/lab.service';

declare var $: any;
@Component({
  selector: 'app-add-lab-lead-modal',
  templateUrl: './add-lab-lead-modal.component.html',
  styleUrls: ['./add-lab-lead-modal.component.css']
})
export class AddLabLeadModalComponent implements OnInit {
  dialogData:any;labLeadModalForm: FormGroup;loading:boolean=false;submitted:boolean=false;dataLoaded:boolean=false;labTest = []; labTest_copy = [];labTestSubcategory =[];
  labTestSubcategory_copy =[];fileExits:boolean=false;allUploads=[];lead_sources=[];
  constructor(public dialogRef: MatDialogRef<AddLabLeadModalComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog,private dialog:MatDialog,
  private router:Router,private sharedapi:SharedService, private leadapi:LeadsService,private formBuilder: FormBuilder, private labapi: LabService) {
    this.dialogData=data;
    let contactPattern = "[[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*]*";
    this.labLeadModalForm = this.formBuilder.group({
      'name' : [null, Validators.required],
      'mobile': [null, Validators.compose([Validators.required, Validators.pattern(contactPattern)])],
      'lab_test_category': [null, Validators.required],
      'lab_test_subcategory': [null, Validators.required],
      'bd_description': [null],
      'patient_address': [null],
      'aadhar': [null],
      'lead_source':[null]
      
    });
  }

  ngOnInit(): void {
    this.getLeadDetail();
    this.getLabTestCategory();
    this.getLeadSources();
  }

  get f() { return this.labLeadModalForm.controls; }

  async getLeadSources()
    {
        this.leadapi.getLeadSources().subscribe((data:any) => {
            if(data.status)
            {
                this.lead_sources = data.data;
            }else{
                this.lead_sources = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    
        
    }
  

  setSearchValue(type) {
    if (type == 'labtest') {
        $("#testSearch").val('');
        $("#testSearch").focus();
        this.labTest = this.labTest_copy;
    }
    else if (type == 'labtestsub') {
        $("#categorySearch").val('');
        $("#categorySearch").focus();
        this.labTestSubcategory = this.labTestSubcategory_copy;
    }
  }

  searchOnSelect(searchtText: string, type) {
      if (type == 'labtest') {
          this.labTest = this.sharedapi.searchData(searchtText, this.labTest_copy, "name");
      }else if (type == 'labtestsub') {
          this.labTestSubcategory = this.sharedapi.searchData(searchtText, this.labTestSubcategory_copy, "name");
      }

  }

  async getLeadDetail()
  {
    this.dataLoaded = false;
    await this.leadapi.getLeadDetail(this.dialogData.lead_id).subscribe((data: any) => {
      this.dataLoaded = true;
      if(data.status)
      {
        this.labLeadModalForm.controls['name'].setValue(data.data.lead_name);
        this.labLeadModalForm.controls['mobile'].setValue(data.data.mobile);
        this.labLeadModalForm.controls['lead_source'].setValue(data.data.lead_source);
        
      } else {
        this.sharedapi.checkError(data.msg);
      }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  async getLabTestCategory() {
    await this.labapi.getLabTestCategory().subscribe((data: any) => {
        if (data.status) {
            this.labTest = data.data;
            this.labTest_copy = this.labTest;
        } else {
            this.labTest = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
}

async getLabTestCategorySubcategory(lab_test_id)
{
    let qString = 'lab_test_id='+lab_test_id;
    await this.labapi.getLabTestCategorySubcategory(qString).subscribe((data:any) => {
        if(data.status)
        {
            this.labTestSubcategory = data.data;
            this.labTestSubcategory_copy = this.labTestSubcategory;
        }else{
            this.labTestSubcategory = [];
        }
    }, error => {
        this.sharedapi.checkError(error);
    });

}

  async submitLabLead()
  {
    
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if (this.labLeadModalForm.invalid) {
        this.loading = false;
        return;
    }
    //For Add Lead//
    //console.log(this.labLeadModalForm); 
    //return false;
    const formData = new FormData();
    formData.append('aadhar', this.labLeadModalForm.get('aadhar').value);
    formData.append('name', this.labLeadModalForm.get('name').value);
    formData.append('mobile', this.labLeadModalForm.get('mobile').value);
    formData.append('lab_test_category', this.labLeadModalForm.get('lab_test_category').value);
    formData.append('lab_test_subcategory', this.labLeadModalForm.get('lab_test_subcategory').value);
    formData.append('bd_description', this.labLeadModalForm.get('bd_description').value);
    formData.append('patient_address', this.labLeadModalForm.get('patient_address').value);
    formData.append('lead_id', this.dialogData.lead_id);
    formData.append('lead_source', this.labLeadModalForm.get('lead_source').value);
    
    await this.labapi.addLeadByAgent(formData)
    .subscribe((data: any) => {
      console.log(data);
        this.submitted = false;
        this.loading = false;
        if (data.status) {
          this.dialogRef.close();
          this.sharedapi.presentToast('Lab data has been submitted successfully.');
        }
        else 
        {
          this.sharedapi.presentToast(data.msg);
        }
    }, error => {
        this.sharedapi.checkError(error);
    });
  }

  CloseModal(): void {
    this.dialogRef.close();
  }

  selectAadhar(event)
  {
      const file = (event.target as HTMLInputElement).files[0];
      this.labLeadModalForm.patchValue({
        aadhar: file
      });

  }

}
